<template>
    <NuxtPage :name="website.view"></NuxtPage>
    <helper v-if="!['Home', 'Chatagent'].includes(($route.meta.route || '') as string)" />
    <cookies />
</template>

<script lang="ts" setup>
//* 公共组件
import { Helper, Cookies } from "@/components/complete";
//* i18n配置
import { i18nOption } from "@/app/i18n";
//* 公共工具函数
import { Formats } from "@/assets/js";

//* Vue插件引入
const i18n = useI18n();
const route = useRoute();
//* store数据
const user = useUserStore();
const website = useWebsiteStore();
//* 获取全局变量
const config = useRuntimeConfig();
//* cookie数据
const token = useCookie("X-Token", { maxAge: 1296000 });
//* 获取网站TDK配置
const setting = await api.server("Setting", "/api/v1/common/setting", {
    data: { url: route.path },
    // data: { url: route.path.replace(/^\/zh/, "") },
});

//* 初始化全局文案翻译
i18n.locale.value = (route.meta?.routeLanguage || i18nOption.locale) as string;

//* 监听Token数据变化
const cookie: { stop?: () => void } = {};

//* 组件卸载时, 注销侦听器
onBeforeUnmount(() => cookie.stop?.());
//* 组件挂载时, 注册侦听器
onMounted(() => {
    //* 初始化Token数据
    token.value = Formats.query(route.query.access_token) || token.value;
    //* 移除URL中的Token数据
    if (route.query.access_token) {
        const url = new URL(window.location.href);
        url.searchParams.delete("access_token");
        history.replaceState({}, "", url.pathname + url.search);
    }

    //* 注册路由中间件
    cookie.stop = watch(token, async () => await user.init());
});

//* 更新网站TDK
useHead({
    title: setting.value?.title || i18n.t("RareDiseaseDataCenter"),
    meta: [
        { name: "keywords", content: setting.value?.keyword || i18n.t("RareDiseaseDataCenter") },
        { name: "description", content: setting.value?.description || i18n.t("RareDiseaseDataCenter") },
        { name: "language", content: i18n.locale.value || "zh" },
        { property: "og:title", content: setting.value?.title || i18n.t("RareDiseaseDataCenter") },
        { property: "og:description", content: setting.value?.description || i18n.t("RareDiseaseDataCenter") },
        { property: "og:type", content: "website" },
        { property: "og:url", content: config.public.BASE_LINK_PREFIX + route.path },
        {
            property: "og:image",
            content:
                i18n.locale.value === "zh"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/f6eb5253ec4b55073bd357b8634aa82d.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/f5dff4a0ff2734bfe0c07d4c22f4c84a.webp",
        },
        { property: "twitter:card", content: "summary_large_image" },
        { property: "twitter:title", content: setting.value?.title || i18n.t("RareDiseaseDataCenter") },
        { property: "twitter:description", content: setting.value?.description || i18n.t("RareDiseaseDataCenter") },
        {
            property: "twitter:image",
            content:
                i18n.locale.value === "zh"
                    ? "https://rdgta.cdn.cyagen.com/rddc/pictures/f6eb5253ec4b55073bd357b8634aa82d.webp"
                    : "https://rdgta.cdn.cyagen.com/rddc/pictures/f5dff4a0ff2734bfe0c07d4c22f4c84a.webp",
        },
    ],
    link: [
        {
            rel: "alternate",
            hreflang: "en",
            href: config.public.BASE_LINK_PREFIX + (i18n.locale.value === "en" ? route.path : route.path.replace(/^\/zh/, "")),
        },
        {
            rel: "alternate",
            hreflang: "zh-CN",
            href: config.public.BASE_LINK_PREFIX + (i18n.locale.value === "zh" ? route.path : "/zh" + route.path),
        },
        {
            rel: "alternate",
            hreflang: "x-default",
            href: config.public.BASE_LINK_PREFIX + (i18n.locale.value === "en" ? route.path : route.path.replace(/^\/zh/, "")),
        },
        { rel: "canonical", href: config.public.BASE_LINK_PREFIX + route.path },
    ],
    htmlAttrs: {
        lang: i18n.locale.value || "zh",
    },
});
</script>
